export default "__VITE_ASSET__C8QM6o4I__"